import React, {Fragment} from "react";
import {withLazyDynamicTable} from "../../../ui/hoc/LazyDynamicTable";
import {TableRow} from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import {TableLoadingRow} from "../../../ui/table/TableLoadingRow";
import {TableEmptyRow} from "../../../ui/table/TableEmptyRow";
import {useTranslation} from "react-i18next";
import {searchContacts} from "../../../../api/machine-functions";
import {httpPost} from "../../../../api/http-functions";
import {MachineContactDataRow} from "./MachineContactDataRow";


export const _ViewMachineContacts = ({
                                         loading,
                                         data: machineContacts,
                                         onRemoveContact
                                     }: any) => {
    const {t} = useTranslation();

    return (
        <Fragment>
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell>
                        <label>
                            {t('_Common.Labels.User')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.Contacts.Status.Title')}
                        </label>
                    </TableCell>
                    <TableCell>

                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    loading ?
                        <TableLoadingRow colSpan={4}/> :
                        machineContacts.length === 0 ?
                            <TableEmptyRow messageKey={'Machine.Contacts.EmptyMessage'}/> :
                            machineContacts.map((c: any) => <MachineContactDataRow key={`contact-${c.userId}`}
                                                                                   onRemoveContact={onRemoveContact} {...c} />)
                }
            </TableBody>
        </Fragment>
    );
};

export const MachineContacts = (props: any) => {
    const {userId} = props;
    const query = ({
                       page,
                       size,
                       filter
                   }: any) => {
        const search = searchContacts(httpPost);
        return search({userId, size, page, filter});
    };

    return withLazyDynamicTable(_ViewMachineContacts, query, ['userId'])(props);
};
